import { Route, Routes } from 'react-router-dom'
import {
  PAGE_USER_MGMT,
  PAGE_DASHBOARD,
  PAGE_LOGIN,
  PAGE_MASTER_DATA,
  PAGE_NOT_FOUND,
  PAGE_FUNC_JOBS,
  PAGE_STORE_MGMT,
  PAGE_ERP_API_LOGS,
  PAGE_POS_API_LOGS,
  PAGE_FTP_CREATION_LOGS,
  PAGE_AGGREGATOR_API_LOG,
  PAGE_IMPORT_LOGS,
  PAGE_SMART_OOS,
  PAGE_INVENTORY,
  PAGE_AGGREGATOR_MANAGEMENT,
  PAGE_FTP_CONFIG,
  PAGE_PRICING,
  PAGE_CONFIG,
  PAGE_ADD_USER,
  PAGE_UPDATE_USER,
  PAGE_FORGOT_PASSWORD,
  PAGE_RESET_PASSWORD,
  PAGE_PRICING_UPDATE,
  PAGE_MASTER_DATA_UPDATE,
  PAGE_INVENTORY_UPDATE,
  PAGE_ADD_AGGREGATOR,
  PAGE_UPDATE_AGGREGATOR,
  PAGE_EXPORT_LOGS,
  PAGE_ADD_STORE,
  PAGE_UPDATE_STORE,
  PAGE_ADMIN_ORDERS,
  PAGE_ADMIN_ORDERS_DETAILS,
  // PAGE_STORE_ORDERS,
  PAGE_ORDERS_LOGS,
  PAGE_RECONCILIATION_LOGS,
  PAGE_PARTIAL_RMA,
  PAGE_RMA_DETAILS,
} from 'utils/constants'

import {
  AggregatorsManagement,
  Configurations,
  Dashboard,
  ForgotPassword,
  FtpConfigurations,
  FunctionAndJobs,
  Inventory,
  Pricing,
  UpdatePricing,
  AggregatorApi,
  ErpApi,
  FtpCreation,
  ImportLog,
  PosApi,
  Login,
  MasterData,
  NotFound,
  SmartOOS,
  StoreManagement,
  UserManagement,
  AddUser,
  MasterDataUpdate,
  CreatePassword,
  UpdateInventory,
  CreateAggregator,
  UpdateAggregator,
  CreateStorePage,
  UpdateStorePage,
  OrderListPage,
  OrderDetailsPage,
  // OrdersByStorePage,
  RmaDetailsPage,
} from 'pages'
import MainLayout from 'layout/mainLayout'
import PageAccessWrapper from 'components/pageAccessWrapper'
import LogoLayout from 'layout/logoLayout'
import ExportLog from 'pages/logPages/exportLog'
import OrdersLog from 'pages/logPages/ordersLog'
import ReconciliationLog from 'pages/logPages/reconciliationLog'
import PartialRmaPage from 'pages/orderManagement/partialRmaPage'
import UpdateUser from 'pages/userManagement/updateUser'

const RoutesProvider = () => {
  return (
    <Routes>
      {/*//* PUBLIC PAGE */}
      <Route element={<LogoLayout />}>
        <Route path={PAGE_LOGIN.path} element={<Login />} />
        <Route path={PAGE_FORGOT_PASSWORD.path} element={<ForgotPassword />} />
        <Route
          path={`${PAGE_RESET_PASSWORD.path}/:id`}
          element={<CreatePassword />}
        />
      </Route>

      <Route element={<MainLayout />}>
        {/* //! PERMISSION BASED PAGES */}
        <Route element={<PageAccessWrapper />}>
          <Route path={PAGE_DASHBOARD.path} element={<Dashboard />} />

          {/* User Management */}
          <Route path={PAGE_USER_MGMT.path} element={<UserManagement />} />

          <Route path={PAGE_MASTER_DATA.path} element={<MasterData />} />
          <Route path={PAGE_STORE_MGMT.path} element={<StoreManagement />} />

          {/* Logs */}
          <Route path={PAGE_ERP_API_LOGS.path} element={<ErpApi />} />
          <Route path={PAGE_POS_API_LOGS.path} element={<PosApi />} />
          <Route path={PAGE_FTP_CREATION_LOGS.path} element={<FtpCreation />} />
          <Route path={PAGE_IMPORT_LOGS.path} element={<ImportLog />} />
          <Route path={PAGE_EXPORT_LOGS.path} element={<ExportLog />} />
          <Route path={PAGE_ORDERS_LOGS.path} element={<OrdersLog />} />
          <Route
            path={PAGE_RECONCILIATION_LOGS.path}
            element={<ReconciliationLog />}
          />
          <Route
            path={PAGE_AGGREGATOR_API_LOG.path}
            element={<AggregatorApi />}
          />

          <Route path={PAGE_SMART_OOS.path} element={<SmartOOS />} />
          <Route path={PAGE_INVENTORY.path} element={<Inventory />} />
          <Route
            path={PAGE_AGGREGATOR_MANAGEMENT.path}
            element={<AggregatorsManagement />}
          />
          <Route path={PAGE_FTP_CONFIG.path} element={<FtpConfigurations />} />
          <Route path={PAGE_PRICING.path} element={<Pricing />} />

          {/* Order Management */}
          <Route path={PAGE_ADMIN_ORDERS.path} element={<OrderListPage />} />

          <Route
            path={`${PAGE_ADMIN_ORDERS_DETAILS.path}/:orderId`}
            element={<OrderDetailsPage />}
          />

          <Route
            path={`${PAGE_RMA_DETAILS.path}/:rmaId`}
            element={<RmaDetailsPage />}
          />

          {/* <Route
            path={PAGE_STORE_ORDERS.path}
            element={<OrdersByStorePage />}
          /> */}
        </Route>

        {/* //* EDITOR ROUTES */}
        <Route element={<PageAccessWrapper checkEditAccess />}>
          <Route path={PAGE_CONFIG.path} element={<Configurations />} />

          <Route path={PAGE_FUNC_JOBS.path} element={<FunctionAndJobs />} />

          {/* User Management */}
          <Route path={PAGE_ADD_USER.path} element={<AddUser />} />
          <Route
            path={`${PAGE_UPDATE_USER.path}/:id`}
            element={<UpdateUser />}
          />

          {/* Master Data */}
          <Route
            path={`${PAGE_MASTER_DATA_UPDATE.path}/:id`}
            element={<MasterDataUpdate />}
          />

          {/* Inventory Page */}
          <Route
            path={`${PAGE_INVENTORY_UPDATE.path}/:id`}
            element={<UpdateInventory />}
          />

          {/* Pricing Page */}
          <Route
            path={`${PAGE_PRICING_UPDATE.path}/:id`}
            element={<UpdatePricing />}
          />

          {/* Aggregator Page */}
          <Route
            path={`${PAGE_ADD_AGGREGATOR.path}`}
            element={<CreateAggregator />}
          />

          <Route
            path={`${PAGE_UPDATE_AGGREGATOR.path}/:id`}
            element={<UpdateAggregator />}
          />

          {/* Store Page */}
          <Route
            path={`${PAGE_ADD_STORE.path}`}
            element={<CreateStorePage />}
          />

          <Route
            path={`${PAGE_UPDATE_STORE.path}/:id`}
            element={<UpdateStorePage />}
          />

          {/* Order Management */}
          <Route
            path={`${PAGE_PARTIAL_RMA.path}/:orderId/generate`}
            element={<PartialRmaPage />}
          />
        </Route>
      </Route>

      {/* //! PAGE NOT FOUND  */}
      <Route path={PAGE_NOT_FOUND.path} element={<NotFound />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  )
}

export default RoutesProvider
